/* NUVA editorial — "Empieza tu negocio" (Fase 3)
   ----------------------------------------------------------------
   Todo lo que depende de los niveles sale de snippets/nuva-kit-config.liquid;
   precios y enlaces, de Shopify (JSON [data-nve-emp-productos] que imprime la
   sección con product.price / product.url). Aquí: perfiles, "después de tu
   compra", comparador (tabla en escritorio · dos niveles lado a lado en móvil),
   cuestionario y preguntas automáticas. Nunca utilidades, ganancias, plazos,
   garantías, formularios ni formas de pago. */
(function () {
  'use strict';

  var CAT_ORDER = ['pants', 'playeras', 'shorts', 'calcetasPacks'];

  function leerJSON(sel) {
    var s = document.querySelector(sel);
    if (!s) return null;
    try { return JSON.parse(s.textContent); } catch (e) { return null; }
  }
  function nodo(tag, cls, txt) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (txt != null) n.textContent = txt;
    return n;
  }
  function sinNuva(nombre) { return String(nombre || '').replace(/^NUVA\s+/i, ''); }
  function lista(nombres) {
    if (nombres.length <= 1) return nombres.join('');
    return nombres.slice(0, -1).join(', ') + ' y ' + nombres[nombres.length - 1];
  }

  function init(root) {
    if (root._nveEmp) return;
    root._nveEmp = true;
    var cfg = leerJSON('script[data-nuva-kit-config]');
    var prods = leerJSON('script[data-nve-emp-productos]') || {};
    if (!cfg || !cfg.kits) return;
    var kits = cfg.kits.filter(function (k) { return prods[k.id]; });
    var cats = {};
    (cfg.categories || []).forEach(function (c) { cats[c.key] = c; });
    var porId = {};
    kits.forEach(function (k, i) { porId[k.id] = { kit: k, i: i }; });

    /* ---------- Perfiles: el "por qué" sale de "paraQuien" de cada nivel ---------- */
    root.querySelectorAll('[data-nve-emp-perfil]').forEach(function (a) {
      var d = porId[a.getAttribute('data-nve-emp-perfil')];
      var t = a.querySelector('[data-nve-emp-porque]');
      if (d && t) t.textContent = d.kit.paraQuien || d.kit.tagline || '';
    });

    /* ---------- Paso 4: "Después de tu compra" agrupado por texto de kit-config ---------- */
    var despues = root.querySelector('[data-nve-emp-despues]');
    if (despues) {
      var porTexto = [];
      kits.forEach(function (k) {
        if (!k.despuesDeCompra) return;
        var g = porTexto.filter(function (x) { return x.texto === k.despuesDeCompra; })[0];
        if (!g) { g = { texto: k.despuesDeCompra, nombres: [] }; porTexto.push(g); }
        g.nombres.push(k.name);
      });
      porTexto.forEach(function (g) {
        var p = nodo('p', 'nve-emp__despues');
        p.appendChild(nodo('strong', null, lista(g.nombres) + ': '));
        p.appendChild(document.createTextNode(g.texto.replace(/^Después de tu compra,\s*/i, '').replace(/^./, function (c) { return c.toUpperCase(); })));
        despues.appendChild(p);
      });
    }

    /* ---------- Modelo del comparador (una sola fuente para escritorio y móvil) ---------- */
    var grupos = [];
    grupos.push({ titulo: 'Inventario', filas: [
      { et: 'Unidades comerciales', v: kits.map(function (k) { return String(k.unidadesComerciales); }) },
      { et: 'Piezas en total', v: kits.map(function (k) { return String(k.piezasFisicas); }) }
    ].concat(CAT_ORDER.filter(function (c) { return cats[c]; }).map(function (c) {
      return { et: cats[c].label, v: kits.map(function (k) { return k.composition[c] > 0 ? String(k.composition[c]) : false; }) };
    })) });
    grupos.push({ titulo: 'Selección', filas: [
      { et: 'Forma de selección', v: kits.map(function (k) { return k.customizable ? '"NUVA elige mi surtido" o mezcla personalizada' : 'Colores y tallas a cargo de NUVA'; }) }
    ] });
    var recursos = [];
    kits.forEach(function (k) { (k.recursos || []).forEach(function (r) { if (r !== 'Inventario' && recursos.indexOf(r) < 0) recursos.push(r); }); });
    grupos.push({ titulo: 'Lo que incluye', filas: recursos.map(function (r) {
      return { et: r, v: kits.map(function (k) { return (k.recursos || []).indexOf(r) >= 0; }) };
    }) });
    if (cfg.soporte && cfg.soporte.nombre) {
      grupos.push({ titulo: 'Soporte', filas: [{ et: cfg.soporte.texto || cfg.soporte.nombre, v: kits.map(function () { return true; }) }] });
    }

    function valorNodo(v, nombreKit) {
      var span = nodo('span', 'nve-emp__valor');
      if (nombreKit) span.appendChild(nodo('span', 'nve-sr-only', nombreKit + ': '));
      if (v === true) { span.classList.add('is-si'); span.appendChild(nodo('span', 'nve-emp__check', '✓')); span.appendChild(nodo('span', 'nve-emp__valor-txt', 'Incluido')); }
      else if (v === false) { span.classList.add('is-no'); span.appendChild(nodo('span', null, '—')); span.appendChild(nodo('span', 'nve-sr-only', 'No incluido')); }
      else span.appendChild(document.createTextNode(v));
      return span;
    }

    /* Escritorio: tabla completa, cabecera fija al desplazarse */
    var mTabla = root.querySelector('[data-nve-emp-comp-tabla]');
    if (mTabla) {
      var t = nodo('table', 'nve-emp__tabla');
      var cap = nodo('caption', 'nve-sr-only', 'Qué incluye cada nivel NUVA');
      t.appendChild(cap);
      var thead = nodo('thead'), tr = nodo('tr');
      var th0 = nodo('th'); th0.scope = 'col'; th0.appendChild(nodo('span', 'nve-sr-only', 'Característica')); tr.appendChild(th0);
      kits.forEach(function (k, i) {
        var th = nodo('th'); th.scope = 'col';
        var a = nodo('a', 'nve-emp__th'); a.href = prods[k.id].url;
        a.appendChild(nodo('span', 'nve-label nve-label--muted', 'Nivel ' + (i + 1)));
        a.appendChild(nodo('span', 'nve-display nve-emp__th-nombre', sinNuva(k.name)));
        a.appendChild(nodo('span', 'nve-emp__th-precio', prods[k.id].precio));
        th.appendChild(a); tr.appendChild(th);
      });
      thead.appendChild(tr); t.appendChild(thead);
      var tbody = nodo('tbody');
      grupos.forEach(function (g) {
        var trg = nodo('tr', 'nve-emp__grupo'), thg = nodo('th', null, g.titulo);
        thg.scope = 'rowgroup'; thg.colSpan = kits.length + 1; trg.appendChild(thg); tbody.appendChild(trg);
        g.filas.forEach(function (f) {
          var r = nodo('tr'), th = nodo('th', null, f.et); th.scope = 'row'; r.appendChild(th);
          f.v.forEach(function (v) { var td = nodo('td'); td.appendChild(valorNodo(v)); r.appendChild(td); });
          tbody.appendChild(r);
        });
      });
      t.appendChild(tbody);
      var tfoot = nodo('tfoot'), trf = nodo('tr'), thf = nodo('th'); thf.scope = 'row'; thf.appendChild(nodo('span', 'nve-sr-only', 'Página de cada nivel')); trf.appendChild(thf);
      kits.forEach(function (k) {
        var td = nodo('td'), a = nodo('a', 'nve-link', 'Ver ' + sinNuva(k.name)); a.href = prods[k.id].url;
        a.appendChild(nodo('span', 'nve-sr-only', ' (' + k.name + ')'));
        td.appendChild(a); trf.appendChild(td);
      });
      tfoot.appendChild(trf); t.appendChild(tfoot);
      mTabla.appendChild(t);
    }

    /* Móvil: dos niveles lado a lado (sin desplazamiento horizontal), nombres fijos arriba */
    var mMovil = root.querySelector('[data-nve-emp-comp-movil]');
    if (mMovil && kits.length > 1) {
      var sel = [0, 1];
      var ctr = nodo('div', 'nve-emp__cm-controles');
      var selects = [0, 1].map(function (n) {
        var lab = nodo('label', 'nve-emp__cm-sel');
        lab.appendChild(nodo('span', 'nve-label nve-label--muted', n === 0 ? 'Nivel A' : 'Nivel B'));
        var s = nodo('select');
        kits.forEach(function (k, i) { var o = nodo('option', null, k.name); o.value = String(i); if (i === sel[n]) o.selected = true; s.appendChild(o); });
        lab.appendChild(s); ctr.appendChild(lab);
        return s;
      });
      mMovil.appendChild(ctr);
      var cab = nodo('div', 'nve-emp__cm-cab');
      mMovil.appendChild(cab);
      var cuerpo = nodo('div', 'nve-emp__cm-cuerpo');
      mMovil.appendChild(cuerpo);

      var pintar = function () {
        sel = [parseInt(selects[0].value, 10), parseInt(selects[1].value, 10)];
        cab.innerHTML = '';
        sel.forEach(function (i) {
          var k = kits[i], a = nodo('a', 'nve-emp__cm-nivel'); a.href = prods[k.id].url;
          a.appendChild(nodo('span', 'nve-display nve-emp__cm-nombre', sinNuva(k.name)));
          a.appendChild(nodo('span', 'nve-emp__cm-precio', prods[k.id].precio));
          cab.appendChild(a);
        });
        cuerpo.innerHTML = '';
        grupos.forEach(function (g) {
          cuerpo.appendChild(nodo('p', 'nve-label nve-emp__cm-grupo', g.titulo));
          g.filas.forEach(function (f) {
            var fila = nodo('div', 'nve-emp__cm-fila');
            fila.setAttribute('role', 'group');
            fila.setAttribute('aria-label', f.et);
            fila.appendChild(nodo('p', 'nve-emp__cm-et', f.et));
            var vals = nodo('div', 'nve-emp__cm-vals');
            sel.forEach(function (i) { vals.appendChild(valorNodo(f.v[i], kits[i].name)); });
            fila.appendChild(vals);
            cuerpo.appendChild(fila);
          });
        });
      };
      selects.forEach(function (s) { s.addEventListener('change', pintar); });
      pintar();
    }

    /* ---------- Preguntas automáticas desde kit-config ---------- */
    var faq = root.querySelector('[data-nve-emp-faq]');
    function pregunta(p, r) {
      if (!faq || !r) return;
      var w = nodo('div', 'nve-emp__faq-item'); w.appendChild(nodo('dt', null, p)); w.appendChild(nodo('dd', null, r)); faq.appendChild(w);
    }
    if (cfg.soporte && cfg.soporte.texto) pregunta('¿Qué soporte incluye cada nivel?', cfg.soporte.texto + ' ' + (cfg.soporte.aplicaA || ''));
    var ac = cfg.acompanamiento || {};
    var conAc = kits.filter(function (k) { return (k.recursos || []).some(function (r) { return /asesor/i.test(r); }); }).map(function (k) { return k.name; });
    if (conAc.length) pregunta('¿Qué niveles incluyen asesorías?', (ac.nombre || 'Asesorías') + (ac.frecuencia ? ' (' + ac.frecuencia + ')' : '') + ': solo en ' + lista(conAc) + '.');
    var tiendaKit = kits.filter(function (k) { return (k.recursos || []).some(function (r) { return /tienda online/i.test(r); }); })[0];
    if (tiendaKit) {
      var tr0 = (tiendaKit.recursos || []).filter(function (r) { return /tienda online/i.test(r); })[0];
      pregunta('¿Qué nivel incluye una tienda online?', tiendaKit.name + ': ' + tr0.charAt(0).toLowerCase() + tr0.slice(1) + '.');
    }

    /* ---------- Cuestionario ---------- */
    initQuiz(root, kits, prods);

    /* ---------- Móvil: los botones flotantes (WhatsApp y música) se ocultan mientras el encabezado
       de la página está en pantalla — misma regla CSS que la Home y las páginas de producto ---------- */
    var hero = root.querySelector('.nve-emp__hero');
    if (hero && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        document.documentElement.classList.toggle('nve-hero-en-pantalla', en[0].isIntersecting);
      }, { rootMargin: '-72px 0px 0px 0px' }).observe(hero);
    }
  }

  function initQuiz(root, kits, prods) {
    var form = root.querySelector('[data-nve-emp-quiz-form]');
    var res = root.querySelector('[data-nve-emp-resultado]');
    var err = root.querySelector('[data-nve-emp-quiz-error]');
    if (!form || !res) return;

    // Nivel mínimo que cubre cada necesidad, derivado de kit-config (nunca una lista fija de ids).
    function primero(pred) { for (var i = 0; i < kits.length; i++) if (pred(kits[i])) return i; return kits.length - 1; }
    var tieneRec = function (re) { return function (k) { return (k.recursos || []).some(function (r) { return re.test(r); }); }; };
    var NECESIDAD = {
      prioridad: {
        esencial: { i: 0, motivo: '' },
        inventario: { i: primero(function (k) { return k.composition.playeras > 0; }), motivo: 'más inventario y variedad' },
        personalizar: { i: primero(function (k) { return k.customizable; }), motivo: 'personalizar tu surtido y contar con videos' },
        asesorias: { i: primero(tieneRec(/asesor/i)), motivo: 'asesorías y acompañamiento de negocio' },
        tienda: { i: primero(tieneRec(/tienda online/i)), motivo: 'tu propia tienda online' }
      },
      categorias: {
        basico: { i: 0, motivo: '' },
        playeras: { i: primero(function (k) { return k.composition.playeras > 0; }), motivo: 'playeras' },
        cuatro: { i: primero(function (k) { return k.composition.shorts > 0; }), motivo: 'las cuatro categorías' }
      }
    };

    function valor(nombre) { var el = form.querySelector('input[name="' + nombre + '"]:checked'); return el ? el.value : null; }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var pres = valor('presupuesto'), pri = valor('prioridad'), cat = valor('categorias');
      if (!pres || !pri || !cat) {
        err.hidden = false;
        /* foco en la primera pregunta sin responder */
        var sets = form.querySelectorAll('fieldset');
        for (var i = 0; i < sets.length; i++) { if (!sets[i].querySelector('input:checked')) { sets[i].querySelector('input').focus(); break; } }
        return;
      }
      err.hidden = true;
      var tope = -1;
      kits.forEach(function (k, i) { if (k.id === pres) tope = i; });
      var n1 = NECESIDAD.prioridad[pri], n2 = NECESIDAD.categorias[cat];
      var nec = n1.i >= n2.i ? n1 : n2;
      var iRec = Math.min(nec.i, tope);            // nunca por encima del presupuesto
      var falta = nec.i > tope;                     // lo que busca empieza en un nivel mayor
      mostrar(kits[iRec], falta ? { kit: kits[nec.i], motivo: nec.motivo } : null);
    });

    form.addEventListener('reset', function () {
      setTimeout(function () {
        res.hidden = true; res.innerHTML = ''; err.hidden = true;
        actualizarFinal(null);
        var f = form.querySelector('input'); if (f) f.focus();
      }, 0);
    });

    function mostrar(kit, falta) {
      var p = prods[kit.id];
      res.innerHTML = '';
      res.appendChild(nodo('p', 'nve-label nve-hl', 'Tu nivel recomendado'));
      res.appendChild(nodo('h3', 'nve-display nve-emp__res-nombre', kit.name));
      res.appendChild(nodo('p', 'nve-emp__res-precio', p.precio));
      if (falta) {
        res.appendChild(nodo('p', 'nve-emp__res-aviso', 'Lo que buscas (' + falta.motivo + ') se incluye desde ' + falta.kit.name + ' (' + prods[falta.kit.id].precio + '). Con el presupuesto que indicaste, el nivel que te corresponde es ' + kit.name + '.'));
      }
      if (kit.paraQuien) res.appendChild(nodo('p', 'nve-emp__res-txt', kit.paraQuien));
      res.appendChild(nodo('p', 'nve-emp__res-txt', kit.unidadesComerciales + ' unidades comerciales · ' + kit.piezasFisicas + ' piezas.'));
      res.appendChild(nodo('p', 'nve-label nve-label--muted', 'Incluye'));
      var ul = nodo('ul', 'nve-emp__res-lista');
      (kit.recursos || []).forEach(function (r) { ul.appendChild(nodo('li', null, r)); });
      res.appendChild(ul);
      if (kit.despuesDeCompra) res.appendChild(nodo('p', 'nve-small', kit.despuesDeCompra));
      var a = nodo('a', 'nve-btn nve-btn--lime nve-emp__res-cta', 'Ver ' + kit.name + ' ');
      a.href = p.url;
      a.appendChild(nodo('span', 'nve-btn__arrow', '→')).setAttribute('aria-hidden', 'true');
      res.appendChild(a);
      res.hidden = false;
      res.focus();
      actualizarFinal(kit);
    }

    function actualizarFinal(kit) {
      var cta = root.querySelector('[data-nve-emp-final-cta]');
      var sec = root.querySelector('[data-nve-emp-final-sec]');
      var txt = root.querySelector('[data-nve-emp-final-texto]');
      if (!cta) return;
      if (!cta._orig) cta._orig = { href: cta.getAttribute('href'), html: cta.innerHTML, sec: sec ? { href: sec.getAttribute('href'), txt: sec.textContent } : null, txt: txt ? txt.textContent : '' };
      if (kit) {
        cta.setAttribute('href', prods[kit.id].url);
        cta.innerHTML = '';
        cta.appendChild(document.createTextNode('Ver ' + kit.name + ' '));
        cta.appendChild(nodo('span', 'nve-btn__arrow', '→')).setAttribute('aria-hidden', 'true');
        if (sec) { sec.setAttribute('href', '#comparador'); sec.textContent = 'Comparar los cinco niveles'; }
        if (txt) txt.textContent = 'Según tus respuestas, tu nivel recomendado es ' + kit.name + '.';
      } else {
        cta.setAttribute('href', cta._orig.href); cta.innerHTML = cta._orig.html;
        if (sec && cta._orig.sec) { sec.setAttribute('href', cta._orig.sec.href); sec.textContent = cta._orig.sec.txt; }
        if (txt) txt.textContent = cta._orig.txt;
      }
    }
  }

  function initAll() { document.querySelectorAll('[data-nve-emp]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', function (e) { var r = e.target.querySelector('[data-nve-emp]'); if (r) init(r); });
})();
